
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';

export default function ProductsPage() {
  const [showConsultForm, setShowConsultForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    company: '',
    needs: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d3l5qti96ie05rb9m6hg', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          phone: '',
          email: '',
          company: '',
          needs: '',
          message: ''
        });
        setTimeout(() => {
          setShowConsultForm(false);
          setSubmitStatus('idle');
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: '全部产品' },
    { id: 'pills', name: '精元丸系列' },
    { id: 'tea', name: '养生茶系列' },
    { id: 'balm', name: '外用膏系列' }
  ];

  const products = [
    {
      id: 1,
      name: "狮虎精元丸",
      subtitle: "Lion Tiger Essence Pills",
      description: "融合云南道地药材与泰国天然草本，专为现代男性精力提升而研制。采用传统工艺结合现代科技，确保每一粒都蕴含最纯正的药效。",
      image: "https://public.readdy.ai/ai/img_res/1a1f1f0fb681d2d277dbb04adeb602ba.jpg",
      features: ["精力提升", "体质调理", "天然配方", "无副作用"],
      price: "¥298",
      originalPrice: "¥398",
      category: "pills",
      rating: 4.8,
      reviews: 156,
      inStock: true
    },
    {
      id: 2,
      name: "虎骨强身茶",
      subtitle: "Tiger Bone Strength Tea",
      description: "传承古法配制，结合现代工艺，为忙碌男性打造的日常养生茶饮。精选优质茶叶与珍贵药材，口感醇厚，功效显著。",
      image: "https://readdy.ai/api/search-image?query=Premium%20Chinese%20herbal%20tea%20in%20elegant%20packaging%20with%20traditional%20design%20elements%2C%20luxury%20tea%20box%20with%20gold%20details%2C%20professional%20product%20photography%2C%20clean%20background%2C%20representing%20strength%20and%20wellness&width=400&height=400&seq=product-002&orientation=squarish",
      features: ["日常养生", "古法传承", "现代工艺", "口感醇厚"],
      price: "¥188",
      originalPrice: "¥258",
      category: "tea",
      rating: 4.7,
      reviews: 89,
      inStock: true
    },
    {
      id: 3,
      name: "狮王活力膏",
      subtitle: "Lion King Vitality Balm",
      description: "泰国草本精华与中医理论完美结合，外用调理，内外兼修。温和不刺激，适合长期使用，效果持久稳定。",
      image: "https://readdy.ai/api/search-image?query=Premium%20herbal%20balm%20in%20sophisticated%20dark%20jar%20with%20gold%20labeling%2C%20luxury%20skincare%20product%20photography%2C%20traditional%20Chinese%20medicine%20external%20application%2C%20clean%20background%2C%20representing%20vitality%20and%20wellness&width=400&height=400&seq=product-003&orientation=squarish",
      features: ["外用调理", "草本精华", "内外兼修", "温和无刺激"],
      price: "¥228",
      originalPrice: "¥298",
      category: "balm",
      rating: 4.9,
      reviews: 203,
      inStock: true
    },
    {
      id: 4,
      name: "龙凤呈祥丸",
      subtitle: "Dragon Phoenix Harmony Pills",
      description: "结合龙马精神与凤凰涅槃的理念，专为追求卓越的成功人士设计。珍贵药材精心配制，助您重焕青春活力。",
      image: "https://readdy.ai/api/search-image?query=Luxury%20traditional%20Chinese%20medicine%20pills%20in%20ornate%20golden%20bottle%20with%20dragon%20and%20phoenix%20motifs%2C%20premium%20herbal%20supplement%20packaging%2C%20professional%20product%20photography%2C%20clean%20background%2C%20representing%20harmony%20and%20vitality&width=400&height=400&seq=product-004&orientation=squarish",
      features: ["珍贵药材", "青春活力", "成功人士", "龙凤配方"],
      price: "¥498",
      originalPrice: "¥698",
      category: "pills",
      rating: 4.9,
      reviews: 78,
      inStock: true
    },
    {
      id: 5,
      name: "仙鹤延年茶",
      subtitle: "Crane Longevity Tea",
      description: "以仙鹤长寿为灵感，精选长白山野生药材与台湾高山茶叶。每日一杯，延年益寿，是养生保健的理想选择。",
      image: "https://readdy.ai/api/search-image?query=Premium%20longevity%20tea%20in%20elegant%20white%20and%20gold%20packaging%20with%20crane%20motifs%2C%20luxury%20herbal%20tea%20box%2C%20professional%20product%20photography%2C%20clean%20background%2C%20representing%20longevity%20and%20wellness&width=400&height=400&seq=product-005&orientation=squarish",
      features: ["延年益寿", "野生药材", "高山茶叶", "日常保健"],
      price: "¥268",
      originalPrice: "¥358",
      category: "tea",
      rating: 4.6,
      reviews: 124,
      inStock: false
    },
    {
      id: 6,
      name: "麒麟护体膏",
      subtitle: "Qilin Protection Balm",
      description: "传说中麒麟具有护体功效，本产品融入这一理念，采用珍稀草本制成。外用涂抹，内在调理，全方位呵护。",
      image: "https://readdy.ai/api/search-image?query=Premium%20protective%20herbal%20balm%20in%20mystical%20dark%20container%20with%20qilin%20mythical%20creature%20design%2C%20luxury%20traditional%20medicine%20packaging%2C%20professional%20product%20photography%2C%20clean%20background%2C%20representing%20protection%20and%20wellness&width=400&height=400&seq=product-006&orientation=squarish",
      features: ["护体功效", "珍稀草本", "全方位呵护", "传统理念"],
      price: "¥358",
      originalPrice: "¥458",
      category: "balm",
      rating: 4.8,
      reviews: 167,
      inStock: true
    }
  ];

  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  const productsSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "狮虎堂产品系列",
    "description": "传承千年智慧，融合现代科技，为您带来最优质的养生产品",
    "url": `${import.meta.env.VITE_SITE_URL}/products`,
    "mainEntity": {
      "@type": "ItemList",
      "numberOfItems": products.length,
      "itemListElement": products.map((product, index) => ({
        "@type": "Product",
        "position": index + 1,
        "name": product.name,
        "description": product.description,
        "image": product.image,
        "offers": {
          "@type": "Offer",
          "price": product.price.replace('¥', ''),
          "priceCurrency": "CNY",
          "availability": product.inStock ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": product.rating,
          "reviewCount": product.reviews
        }
      }))
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="产品系列 - 狮虎堂精选养生产品"
        description="传承千年智慧，融合现代科技，为您带来最优质的养生产品。精元丸系列、养生茶系列、外用膏系列等多种产品供您选择。"
        keywords="狮虎堂产品,精元丸,养生茶,外用膏,男性保健,中草药产品"
        ogImage="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/f35a59635442fe291a9bbc6026c2854c.jfif"
        schema={productsSchema}
      />
      <Header />
      <main className="bg-gray-50">
        {/* Hero Section */}
        <section 
          className="py-20 relative"
        >
          {/* 背景图片层 */}
          <div 
            className="absolute inset-0 bg-contain bg-center bg-no-repeat"
            style={{
              backgroundImage: `url('https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/77fc5d852ceb25e6345b637b8900e89b.png')`
            }}
          ></div>
          
          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#2f3673]/90 to-[#2f3673]/80"></div>
          
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
            <h1 className="text-xl md:text-2xl font-bold text-white mb-6">精选产品系列</h1>
            <p className="text-sm md:text-base text-white/90 max-w-3xl mx-auto">
              传承千年智慧，融合现代科技，为您带来最优质的养生产品
            </p>
          </div>
        </section>

        {/* Category Filter */}
        <section className="py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap justify-center gap-4 mb-12">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-6 py-3 rounded-full text-xs font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                    selectedCategory === category.id
                      ? 'bg-[#f7931d] text-white shadow-lg'
                      : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>

            {/* Products Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
              {filteredProducts.map((product) => (
                <div
                  key={product.id}
                  className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100"
                  data-product-shop
                >
                  {/* Product Image */}
                  <div className="relative h-80 bg-gray-50 overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute top-4 left-4">
                      {!product.inStock && (
                        <div className="bg-gray-500 text-white px-2 py-1 rounded-full text-xs font-medium">
                          缺货
                        </div>
                      )}
                      {product.originalPrice && product.inStock && (
                        <div className="bg-red-500 text-white px-2 py-1 rounded-full text-xs font-medium">
                          限时优惠
                        </div>
                      )}
                    </div>
                    <div className="absolute top-4 right-4">
                      <div className="bg-[#f7931d] text-white px-2 py-1 rounded-full text-xs font-medium">
                        热销
                      </div>
                    </div>
                  </div>

                  {/* Product Info */}
                  <div className="p-6">
                    <div className="mb-4">
                      <h3 className="text-base font-bold text-[#2f3673] mb-1">
                        {product.name}
                      </h3>
                      <p className="text-xs text-gray-500 font-medium">
                        {product.subtitle}
                      </p>
                    </div>

                    {/* Rating */}
                    <div className="flex items-center gap-2 mb-3">
                      <div className="flex items-center">
                        {[...Array(5)].map((_, i) => (
                          <i
                            key={i}
                            className={`ri-star-${i < Math.floor(product.rating) ? 'fill' : 'line'} text-yellow-400 text-xs`}
                          ></i>
                        ))}
                      </div>
                      <span className="text-xs text-gray-600">
                        {product.rating} ({product.reviews}条评价)
                      </span>
                    </div>

                    <p className="text-xs text-gray-600 leading-relaxed mb-4">
                      {product.description}
                    </p>

                    {/* Features */}
                    <div className="flex flex-wrap gap-2 mb-6">
                      {product.features.map((feature, featureIndex) => (
                        <span
                          key={featureIndex}
                          className="bg-orange-50 text-[#f7931d] px-2 py-1 rounded-full text-xs font-medium"
                        >
                          {feature}
                        </span>
                      ))}
                    </div>

                    {/* Price and Action */}
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <div className="text-lg font-bold text-[#2f3673]">
                          {product.price}
                        </div>
                        {product.originalPrice && (
                          <div className="text-xs text-gray-400 line-through">
                            {product.originalPrice}
                          </div>
                        )}
                      </div>
                      <button 
                        className={`px-4 py-2 rounded-full text-xs font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                          product.inStock
                            ? 'bg-[#f7931d] text-white hover:bg-[#e6841a]'
                            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        }`}
                        disabled={!product.inStock}
                      >
                        {product.inStock ? '立即购买' : '暂时缺货'}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Empty State */}
            {filteredProducts.length === 0 && (
              <div className="text-center py-20">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-search-line text-4xl text-gray-400"></i>
                </div>
                <h3 className="text-base font-medium text-gray-900 mb-2">
                  暂无相关产品
                </h3>
                <p className="text-xs text-gray-500">
                  请尝试选择其他分类查看更多产品
                </p>
              </div>
            )}
          </div>
        </section>

        {/* 原始 CTA Section */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="bg-gradient-to-r from-[#2f3673] to-[#f7931d] rounded-2xl p-8 text-white">
              <h2 className="text-lg font-bold mb-4">
                还没找到心仪的产品？
              </h2>
              <p className="text-sm mb-6 opacity-90">
                我们的专业顾问团队随时为您提供个性化推荐
              </p>
              <button 
                onClick={() => setShowConsultForm(true)}
                className="bg-white text-[#2f3673] px-8 py-3 rounded-full text-sm font-semibold hover:bg-gray-100 transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                联系专业顾问
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      {/* 咨询表单弹窗 */}
      {showConsultForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-8">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-lg font-bold text-[#2f3673]">专业顾问咨询</h3>
                <button
                  onClick={() => setShowConsultForm(false)}
                  className="text-gray-400 hover:text-gray-600 text-xl cursor-pointer"
                >
                  <i className="ri-close-line"></i>
                </button>
              </div>

              {submitStatus === 'success' && (
                <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
                  <div className="flex items-center text-green-800">
                    <i className="ri-check-circle-line text-base mr-2"></i>
                    <span className="text-sm">提交成功！我们的专业顾问将在24小时内与您联系。</span>
                  </div>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
                  <div className="flex items-center text-red-800">
                    <i className="ri-error-warning-line text-base mr-2"></i>
                    <span className="text-sm">提交失败，请稍后重试或直接联系我们。</span>
                  </div>
                </div>
              )}

              <form onSubmit={handleSubmit} data-readdy-form id="consultant-form">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      姓名 *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#f7931d] focus:border-transparent text-sm"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      手机号码 *
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#f7931d] focus:border-transparent text-sm"
                      placeholder="请输入您的手机号码"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      邮箱地址
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#f7931d] focus:border-transparent text-sm"
                      placeholder="请输入您的邮箱地址"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      公司/机构
                    </label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#f7931d] focus:border-transparent text-sm"
                      placeholder="请输入您的公司或机构名称"
                    />
                  </div>
                </div>

                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    咨询需求 *
                  </label>
                  <select
                    name="needs"
                    value={formData.needs}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#f7931d] focus:border-transparent text-sm appearance-none bg-white"
                  >
                    <option value="">请选择您的咨询需求</option>
                    <option value="产品选择">产品选择建议</option>
                    <option value="营养方案">个性化营养方案</option>
                    <option value="训练计划">专业训练计划</option>
                    <option value="批量采购">企业批量采购</option>
                    <option value="代理合作">代理合作咨询</option>
                    <option value="其他">其他需求</option>
                  </select>
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                    <i className="ri-arrow-down-s-line text-gray-400"></i>
                  </div>
                </div>

                <div className="mb-8">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    详细描述
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#f7931d] focus:border-transparent text-sm resize-none"
                    placeholder="请详细描述您的需求，我们的专业顾问将为您提供更精准的建议..."
                  />
                  <div className="text-right text-xs text-gray-500 mt-1">
                    {formData.message.length}/500
                  </div>
                </div>

                <div className="flex gap-4">
                  <button
                    type="button"
                    onClick={() => setShowConsultForm(false)}
                    className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  >
                    取消
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="flex-1 px-6 py-3 bg-[#f7931d] text-white rounded-lg hover:bg-[#e8851a] transition-colors duration-300 cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? '提交中...' : '提交咨询'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
